/**
 * @generated SignedSource<<86882a77d65ee07dd4777b4582ad3b1e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutTransactionQueryRenderer_preCheckoutTransaction$data = {
  readonly __typename: "Transaction";
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutLayout_preCheckoutTransaction">;
  readonly " $fragmentType": "CheckoutTransactionQueryRenderer_preCheckoutTransaction";
};
export type CheckoutTransactionQueryRenderer_preCheckoutTransaction$key = {
  readonly " $data"?: CheckoutTransactionQueryRenderer_preCheckoutTransaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutTransactionQueryRenderer_preCheckoutTransaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutTransactionQueryRenderer_preCheckoutTransaction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutLayout_preCheckoutTransaction"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "a3726a2795178b5af90a5e94a1fd0cfa";

export default node;
